/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { emit } from "../../utilites/helpers";
import "./styles.scss";

const TasksArchiveModal = ({ socket, onRequestClose, onTaskClick }) => {
  const archivedTasks = useSelector(({ tasks }) => tasks?.archivedTasks) || [];
  const [searchQuery, setSearchQuery] = useState("");
  const debounceRef = useRef(null);

  useEffect(() => {
    if (!socket) return;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    const delay = searchQuery?.trim() ? 300 : 0;
    debounceRef.current = setTimeout(() => {
      const payload = searchQuery?.trim() ? { title: searchQuery.trim() } : {};
      emit(socket, { action: "task/getArchivedTasks", payload });
    }, delay);
    return () => clearTimeout(debounceRef.current);
  }, [searchQuery, socket]);

  const handleTaskClick = (taskId) => {
    onTaskClick?.();
    window.open(`/review-task/${taskId}`, "_blank");
  };

  const handleUnarchive = (e, taskId) => {
    e.stopPropagation();
    emit(socket, { action: "task/unarchiveTask", payload: { taskId } });
  };

  return (
    <div className="tasks-archive-modal" onClick={(e) => e.stopPropagation()}>
      <div className="tasks-archive-modal-header">
        <div className="close-icon" onClick={onRequestClose} />
        <h2>Архив задачи</h2>
      </div>
      <div className="tasks-archive-modal-body">
        <input
          type="text"
          className="tasks-archive-search"
          placeholder="Търсене по име на задача..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <div className="tasks-archive-list">
          {archivedTasks.length ? (
            archivedTasks.map((task) => (
              <div
                key={task?._id}
                className="tasks-archive-item"
                onClick={() => handleTaskClick(task?._id)}
              >
                <div className="tasks-archive-item-content">
                  <h4>{task?.title}</h4>
                  {task?.endDate && (
                    <span className="tasks-archive-date">
                      Срок: {new Date(task.endDate).toLocaleDateString("bg-BG")}
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  className="tasks-archive-unarchive-btn"
                  onClick={(e) => handleUnarchive(e, task?._id)}
                  title="Възстанови от архив"
                >
                  Възстанови
                </button>
              </div>
            ))
          ) : (
            <p className="tasks-archive-empty">Няма архивирани задачи</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TasksArchiveModal;
